// Mock data for Posi-Products modern clone
// NOTE: All content below is mocked on the frontend. Product links point to the live shop.

export const SHOP_URL = "https://www.motousher.com/collections/posi-products";

export const navLinks = [
  { label: "Home", href: "#home" },
  { label: "Connectors", href: "#connectors" },
  { label: "Shop", href: SHOP_URL, external: true },
  { label: "About", href: "#about" },
  { label: "Contact", href: "#contact" },
];

export const features = [
  {
    icon: "Timer",
    title: "Quick Install",
    desc: "Quick and easy to install — no crimping, no slicing required.",
  },
  {
    icon: "RefreshCw",
    title: "Reusable",
    desc: "Use them again and again. Just hand loosen or hand tighten.",
  },
  {
    icon: "Wrench",
    title: "No Tools",
    desc: "They don't require any tools and fit a wide range of sizes.",
  },
  {
    icon: "ShieldCheck",
    title: "Safe",
    desc: "Do not vibrate loose like the majority of electrical connectors.",
  },
];

export const products = [
  {
    id: "posi-fuse",
    name: "Posi Fuse\u00ae Connectors",
    price: "From Rs. 190.00",
    image:
      "https://www.motousher.com/cdn/shop/products/posi_products_Fuseholder-block.jpg?v=1682085609&width=440",
    link: "https://www.motousher.com/products/electrical-connector-posi-fuse",
    tag: "Fuse",
  },
  {
    id: "posi-lock",
    name: "Posi Lock\u00ae Connector",
    price: "From Rs. 99.00",
    image:
      "https://www.motousher.com/cdn/shop/products/Posi-LOCK.jpg?v=1664730965&width=440",
    link: "https://www.motousher.com/products/electrical-connector-posi-lock",
    tag: "Lock",
  },
  {
    id: "posi-seal",
    name: "Posi Seal\u00ae Connector",
    price: "From Rs. 190.00",
    image:
      "https://www.motousher.com/cdn/shop/products/PosiSealConnectors.jpg?v=1676947492&width=440",
    link: "https://www.motousher.com/products/posi-seal-connector",
    tag: "Seal",
  },
  {
    id: "posi-tap-yellow",
    name: "Posi Tap\u00ae Connector",
    price: "Rs. 180.00",
    image:
      "https://www.motousher.com/cdn/shop/products/Posi-Tap-Yellow.jpg?v=1682239056&width=440",
    link: "https://www.motousher.com/products/posi-tap-connector-6-4sqmm",
    tag: "Tap",
  },
  {
    id: "posi-tap-034",
    name: "Posi Tap\u00ae Connector (0.5 - .34sqmm)",
    price: "Rs. 119.00",
    image:
      "https://www.motousher.com/cdn/shop/products/Posi-TAP_4957abed-bba4-4268-b3ba-648911990f08.jpg?v=1664731806&width=440",
    link: "https://www.motousher.com/products/electrical-connector-posi-tap-20-22ga",
    tag: "Tap",
  },
  {
    id: "posi-tap-075",
    name: "Posi Tap\u00ae Connector (0.75 sqmm)",
    price: "Rs. 180.00",
    image:
      "https://www.motousher.com/cdn/shop/products/Posi-TAP-STRAIGHT.jpg?v=1747908310&width=440",
    link: "https://www.motousher.com/products/electrical-connector-posi-tap-18ga",
    tag: "Tap",
  },
  {
    id: "posi-tap-25",
    name: "Posi Tap\u00ae Connector (2.5-1.5sqmm)",
    price: "Rs. 160.00",
    image:
      "https://www.motousher.com/cdn/shop/products/Posi-Tap-02.5sqmm.jpg?v=1682151974&width=440",
    link: "https://www.motousher.com/products/electrical-connector-posi-tap-14-16ga",
    tag: "Tap",
  },
  {
    id: "posi-tite",
    name: "Posi Tite\u00ae Watertight Connector",
    price: "From Rs. 270.00",
    image:
      "https://www.motousher.com/cdn/shop/products/posi_products_watertight_68c20307-c41f-4691-b14a-a8656e3fea0f.jpg?v=1664730808&width=440",
    link: "https://www.motousher.com/products/posi-tite-watertight-connector",
    tag: "Tite",
  },
  {
    id: "posi-twist",
    name: "Posi Twist\u00ae Connector",
    price: "From Rs. 60.00",
    image:
      "https://www.motousher.com/cdn/shop/products/Posi-TWIST_7434505a-4f82-4831-a0fe-e94d8e609ccb.jpg?v=1664731092&width=440",
    link: "https://www.motousher.com/products/electrical-connector-posi-twist",
    tag: "Twist",
  },
];

export const heroImage =
  "https://images.unsplash.com/photo-1610202926204-c0c9b7d8f112";

export const contact = {
  phone: "+91 (0) 937 37 88088",
  phoneAlt: "+91 99600 88088",
  hours: "Monday - Saturday  |  10:00 AM - 6:30 PM",
  importedBy: "PLUSGROW MERCHANTRY PVT LTD | CIN U51909MH2018PTC318387",
  address: "T-31A MIDC Industrial Area, Hingna Rd, Nagpur 440016",
};

export const footerProducts = [
  { label: "Posi Tap", href: SHOP_URL },
  { label: "Posi Twist", href: SHOP_URL },
  { label: "Posi Lock", href: SHOP_URL },
  { label: "Posi Tite", href: SHOP_URL },
];
